import { render, staticRenderFns } from "./IssueSeniorMaritimePilotCertificate.vue?vue&type=template&id=65da5f9e&scoped=true"
import script from "./IssueSeniorMaritimePilotCertificate.vue?vue&type=script&lang=ts"
export * from "./IssueSeniorMaritimePilotCertificate.vue?vue&type=script&lang=ts"
import style0 from "./IssueSeniorMaritimePilotCertificate.vue?vue&type=style&index=0&id=65da5f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da5f9e",
  null
  
)

export default component.exports